import React from 'react'

const Error = ({ message }) => <p css={`color: red;`}>{message}</p>

export const useError = () => {
  const [ error, setErrorBase ] = React.useState(false)

  const setError = React.useCallback((e) => {
    setErrorBase(e.message)
  }, [ setErrorBase ])

  return { error: <Error message={error} />, setError }
}
